export const footerLinks = {
    'bh-ar': [
        {
            title: 'أفضل الوجهات',
            items: [
                {
                    href: 'https://bh.wingie.com/flights/to-riyadh/',
                    title: 'رياض',
                },
                {
                    href: 'https://bh.wingie.com/flights/to-jeddah/',
                    title: 'جدة',
                },
                {
                    href: 'https://bh.wingie.com/flights/to-dammam/',
                    title: 'الدمام',
                },
                {
                    href: 'https://bh.wingie.com/flights/to-manila/',
                    title: 'مانيلا',
                },
                {
                    href: 'https://bh.wingie.com/flights/to-chennai/',
                    title: 'تشيناي',
                },
                {
                    href: 'https://bh.wingie.com/flights/to-delhi/',
                    title: 'دلهي',
                },
            ],
        },
        {
            title: 'أشهر الدول',
            items: [
                {
                    href: 'https://bh.wingie.com/flights/az-azerbaijan/',
                    title: 'أذربيجان',
                },
                {
                    href: 'https://bh.wingie.com/flights/bh-bahrain/',
                    title: 'البحرين',
                },
                {
                    href: 'https://bh.wingie.com/flights/eg-egypt/',
                    title: 'مصر',
                },
                {
                    href: 'https://bh.wingie.com/flights/in-india/',
                    title: 'الهند',
                },
                {
                    href: 'https://bh.wingie.com/flights/jo-jordan/',
                    title: 'الأردن',
                },
                {
                    href: 'https://bh.wingie.com/flights/ke-kenya/',
                    title: 'كينيا',
                },
            ],
        },
        {
            title: 'أشهر الخطوط الجوية',
            items: [
                {
                    href: 'https://bh.wingie.com/flights/airlines/saudi-arabian-airlines/',
                    title: 'السعودية',
                },
                {
                    href: 'https://bh.wingie.com/flights/airlines/flynas/',
                    title: 'طيران ناس',
                },
                {
                    href: 'https://bh.wingie.com/flights/airlines/qatar-airways/',
                    title: 'الخطوط الجوية القطرية\n',
                },
                {
                    href: 'https://bh.wingie.com/flights/airlines/egyptair/',
                    title: 'مصر للطيران',
                },
                {
                    href: 'https://bh.wingie.com/flights/airlines/etihad-airways/',
                    title: 'شَرِكَة ٱلْاِتِّحَاد لِلطَّيْرَان',
                },
                {
                    href: 'https://bh.wingie.com/flights/airlines/royal-jordanian/',
                    title: 'الملكيَّة الأردنيَّة',
                },
            ],
        },
    ],
    'bh-en': [
        {
            title: 'Top Destinations',
            items: [
                {
                    href: 'https://bh.wingie.com/en/flights/to-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/to-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/to-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/to-cairo/',
                    title: 'Cairo',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/to-istanbul/',
                    title: 'Istanbul',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/to-dubai/',
                    title: 'Dubai',
                },
            ],
        },
        {
            title: 'Popular Countries',
            items: [
                {
                    href: 'https://bh.wingie.com/en/flights/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/bd-bangladesh/',
                    title: 'Bangladesh',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/eg-egypt/',
                    title: 'Egypt',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/fr-france/',
                    title: 'France',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/jo-jordan/',
                    title: 'Jordan',
                },
            ],
        },
        {
            title: 'Popular Airlines',
            items: [
                {
                    href: 'https://bh.wingie.com/en/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/airlines/flyadeal/',
                    title: 'flyadeal',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/airlines/nile-air/',
                    title: 'Nile Air',
                },
                {
                    href: 'https://bh.wingie.com/en/flights/airlines/emirates/',
                    title: 'Emirates',
                },
            ],
        },
    ],
    'bh-es': [
        {
            title: 'Principales destinos',
            items: [
                {
                    href: 'https://bh.wingie.com/es/vuelos/a-riyadh/',
                    title: 'Riyadh',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/a-jeddah/',
                    title: 'Jeddah',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/a-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/a-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/a-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/a-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Países populares',
            items: [
                {
                    href: 'https://bh.wingie.com/es/vuelos/az-azerbaijan/',
                    title: 'Azerbaiyán',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/bh-bahrain/',
                    title: 'Bahréin',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/eg-egypt/',
                    title: 'Egipto',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/in-india/',
                    title: 'India',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/jo-jordan/',
                    title: 'Jordania',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/ke-kenya/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Aerolíneas populares',
            items: [
                {
                    href: 'https://bh.wingie.com/es/vuelos/companias-aereas/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/companias-aereas/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/companias-aereas/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/companias-aereas/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/companias-aereas/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://bh.wingie.com/es/vuelos/companias-aereas/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'bh-de': [
        {
            title: 'Top-Destinationen',
            items: [
                {
                    href: 'https://bh.wingie.com/de/flug/nach-riad/',
                    title: 'Riad',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/nach-dschidda/',
                    title: 'Dschidda',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/nach-dammam/',
                    title: 'Dammam',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/nach-manila/',
                    title: 'Manila',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/nach-chennai/',
                    title: 'Chennai',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/nach-delhi/',
                    title: 'Delhi',
                },
            ],
        },
        {
            title: 'Beliebte Länder',
            items: [
                {
                    href: 'https://bh.wingie.com/de/flug/az-aserbaidschan/',
                    title: 'Aserbaidschan',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/bh-bahrain/',
                    title: 'Bahrain',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/eg-aegypten/',
                    title: 'Ägypten',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/in-indien/',
                    title: 'Indien',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/jo-jordanien/',
                    title: 'Jordanien',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/ke-kenia/',
                    title: 'Kenia',
                },
            ],
        },
        {
            title: 'Beliebte Fluggesellschaften',
            items: [
                {
                    href: 'https://bh.wingie.com/de/flug/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://bh.wingie.com/de/flug/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'bh-ru': [
        {
            title: 'Популярные направления',
            items: [
                {
                    href: 'https://bh.wingie.com/ru/flights/to-riyadh/',
                    title: 'Рияд',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/to-jeddah/',
                    title: 'Джедда',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/to-dammam/',
                    title: 'Даммам',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/to-manila/',
                    title: 'Манила',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/to-chennai/',
                    title: 'Ченнай',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/to-delhi/',
                    title: 'Дели',
                },
            ],
        },
        {
            title: 'Популярные страны',
            items: [
                {
                    href: 'https://bh.wingie.com/ru/flights/az-azerbaijan/',
                    title: 'Азербайджан',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/bh-bahrain/',
                    title: 'Бахрейн',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/eg-egypt/',
                    title: 'Египет',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/in-india/',
                    title: 'Индия',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/jo-jordan/',
                    title: 'Иордания',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/ke-kenya/',
                    title: 'Кения',
                },
            ],
        },
        {
            title: 'Популярные авиакомпании',
            items: [
                {
                    href: 'https://bh.wingie.com/ru/flights/airlines/saudi-arabian-airlines/',
                    title: 'Saudi Arabian Airlines',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/airlines/flynas/',
                    title: 'Flynas',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/airlines/qatar-airways/',
                    title: 'Qatar Airways',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/airlines/egyptair/',
                    title: 'Egyptair',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/airlines/etihad-airways/',
                    title: 'Etihad Airways',
                },
                {
                    href: 'https://bh.wingie.com/ru/flights/airlines/royal-jordanian/',
                    title: 'Royal Jordanian',
                },
            ],
        },
    ],
    'bh-it': [
        {
            title: 'Destinazioni Top',
            items: [
                { href: 'https://bh.wingie.com/it/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://bh.wingie.com/it/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://bh.wingie.com/it/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://bh.wingie.com/it/flights/to-manila/', title: 'Manila' },
                { href: 'https://bh.wingie.com/it/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://bh.wingie.com/it/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Paesi Popolari',
            items: [
                { href: 'https://bh.wingie.com/it/flights/az-azerbaigian/', title: 'Azerbaigian' },
                { href: 'https://bh.wingie.com/it/flights/bh-bahrein/', title: 'Bahrein' },
                { href: 'https://bh.wingie.com/it/flights/eg-egitto/', title: 'Egitto' },
                { href: 'https://bh.wingie.com/it/flights/in-india/', title: 'India' },
                { href: 'https://bh.wingie.com/it/flights/jo-giordania/', title: 'Giordania' },
                { href: 'https://bh.wingie.com/it/flights/ke-kenya/', title: 'Kenya' },
            ],
        },
        {
            title: 'Compagnie Aeree Popolari',
            items: [
                { href: 'https://bh.wingie.com/it/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/it/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/it/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/it/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/it/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/it/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-fr': [
        {
            title: 'Destinations Populaires',
            items: [
                { href: 'https://bh.wingie.com/fr/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://bh.wingie.com/fr/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://bh.wingie.com/fr/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://bh.wingie.com/fr/flights/to-manila/', title: 'Manille' },
                { href: 'https://bh.wingie.com/fr/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://bh.wingie.com/fr/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Pays Populaires',
            items: [
                { href: 'https://bh.wingie.com/fr/flights/az-azerbaidjan/', title: 'Azerbaïdjan' },
                { href: 'https://bh.wingie.com/fr/flights/bh-bahrein/', title: 'Bahreïn' },
                { href: 'https://bh.wingie.com/fr/flights/eg-egypte/', title: 'Égypte' },
                { href: 'https://bh.wingie.com/fr/flights/in-inde/', title: 'Inde' },
                { href: 'https://bh.wingie.com/fr/flights/jo-jordanie/', title: 'Jordanie' },
                { href: 'https://bh.wingie.com/fr/flights/ke-kenya/', title: 'Kenya' },
            ],
        },
        {
            title: 'Compagnies Aériennes Populaires',
            items: [
                { href: 'https://bh.wingie.com/fr/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/fr/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/fr/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/fr/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/fr/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/fr/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-pt': [
        {
            title: 'Destinos Populares',
            items: [
                { href: 'https://bh.wingie.com/pt/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://bh.wingie.com/pt/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://bh.wingie.com/pt/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://bh.wingie.com/pt/flights/to-manila/', title: 'Manila' },
                { href: 'https://bh.wingie.com/pt/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://bh.wingie.com/pt/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Países Populares',
            items: [
                { href: 'https://bh.wingie.com/pt/flights/az-azerbaijao/', title: 'Azerbaijão' },
                { href: 'https://bh.wingie.com/pt/flights/bh-bahrein/', title: 'Bahrein' },
                { href: 'https://bh.wingie.com/pt/flights/eg-egito/', title: 'Egito' },
                { href: 'https://bh.wingie.com/pt/flights/in-india/', title: 'Índia' },
                { href: 'https://bh.wingie.com/pt/flights/jo-jordania/', title: 'Jordânia' },
                { href: 'https://bh.wingie.com/pt/flights/ke-quenia/', title: 'Quénia' },
            ],
        },
        {
            title: 'Companhias Aéreas Populares',
            items: [
                { href: 'https://bh.wingie.com/pt/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/pt/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/pt/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/pt/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/pt/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/pt/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-ro': [
        {
            title: 'Destinații Populare',
            items: [
                { href: 'https://bh.wingie.com/ro/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://bh.wingie.com/ro/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://bh.wingie.com/ro/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://bh.wingie.com/ro/flights/to-manila/', title: 'Manila' },
                { href: 'https://bh.wingie.com/ro/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://bh.wingie.com/ro/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Țări Populare',
            items: [
                { href: 'https://bh.wingie.com/ro/flights/az-azerbaidjan/', title: 'Azerbaidjan' },
                { href: 'https://bh.wingie.com/ro/flights/bh-bahrain/', title: 'Bahrein' },
                { href: 'https://bh.wingie.com/ro/flights/eg-egipt/', title: 'Egipt' },
                { href: 'https://bh.wingie.com/ro/flights/in-india/', title: 'India' },
                { href: 'https://bh.wingie.com/ro/flights/jo-iordania/', title: 'Iordania' },
                { href: 'https://bh.wingie.com/ro/flights/ke-kenya/', title: 'Kenya' },
            ],
        },
        {
            title: 'Companii Aeriene Populare',
            items: [
                { href: 'https://bh.wingie.com/ro/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/ro/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/ro/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/ro/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/ro/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/ro/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-pl': [
        {
            title: 'Popularne Destynacje',
            items: [
                { href: 'https://bh.wingie.com/pl/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://bh.wingie.com/pl/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://bh.wingie.com/pl/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://bh.wingie.com/pl/flights/to-manila/', title: 'Manila' },
                { href: 'https://bh.wingie.com/pl/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://bh.wingie.com/pl/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Popularne Kraje',
            items: [
                { href: 'https://bh.wingie.com/pl/flights/az-azerbejdzan/', title: 'Azerbejdżan' },
                { href: 'https://bh.wingie.com/pl/flights/bh-bahrajn/', title: 'Bahrajn' },
                { href: 'https://bh.wingie.com/pl/flights/eg-egipt/', title: 'Egipt' },
                { href: 'https://bh.wingie.com/pl/flights/in-indie/', title: 'Indie' },
                { href: 'https://bh.wingie.com/pl/flights/jo-jordania/', title: 'Jordania' },
                { href: 'https://bh.wingie.com/pl/flights/ke-kenia/', title: 'Kenia' },
            ],
        },
        {
            title: 'Popularne Linie Lotnicze',
            items: [
                { href: 'https://bh.wingie.com/pl/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/pl/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/pl/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/pl/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/pl/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/pl/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-lt': [
        {
            title: 'Populiarūs Kryptys',
            items: [
                { href: 'https://bh.wingie.com/lt/flights/to-riyadh/', title: 'Riadas' },
                { href: 'https://bh.wingie.com/lt/flights/to-jeddah/', title: 'Džida' },
                { href: 'https://bh.wingie.com/lt/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://bh.wingie.com/lt/flights/to-manila/', title: 'Manila' },
                { href: 'https://bh.wingie.com/lt/flights/to-chennai/', title: 'Čenajus' },
                { href: 'https://bh.wingie.com/lt/flights/to-delhi/', title: 'Delis' },
            ],
        },
        {
            title: 'Populiarios Šalys',
            items: [
                { href: 'https://bh.wingie.com/lt/flights/az-azerbaidzanas/', title: 'Azerbaidžanas' },
                { href: 'https://bh.wingie.com/lt/flights/bh-bahreinas/', title: 'Bahreinas' },
                { href: 'https://bh.wingie.com/lt/flights/eg-egiptas/', title: 'Egiptas' },
                { href: 'https://bh.wingie.com/lt/flights/in-indija/', title: 'Indija' },
                { href: 'https://bh.wingie.com/lt/flights/jo-jordanija/', title: 'Jordanija' },
                { href: 'https://bh.wingie.com/lt/flights/ke-kenija/', title: 'Kenija' },
            ],
        },
        {
            title: 'Populiarios Oro Linijos',
            items: [
                { href: 'https://bh.wingie.com/lt/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/lt/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/lt/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/lt/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/lt/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/lt/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-uz': [
        {
            title: "Mashhur Yo'nalishlar",
            items: [
                { href: 'https://bh.wingie.com/uz/flights/to-riyadh/', title: 'Riyad' },
                { href: 'https://bh.wingie.com/uz/flights/to-jeddah/', title: 'Jidda' },
                { href: 'https://bh.wingie.com/uz/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://bh.wingie.com/uz/flights/to-manila/', title: 'Manila' },
                { href: 'https://bh.wingie.com/uz/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://bh.wingie.com/uz/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Mashhur Davlatlar',
            items: [
                { href: 'https://bh.wingie.com/uz/flights/az-ozarbayjon/', title: 'Ozarbayjon' },
                { href: 'https://bh.wingie.com/uz/flights/bh-bahrayn/', title: 'Bahrayn' },
                { href: 'https://bh.wingie.com/uz/flights/eg-misr/', title: 'Misr' },
                { href: 'https://bh.wingie.com/uz/flights/in-hindiston/', title: 'Hindiston' },
                { href: 'https://bh.wingie.com/uz/flights/jo-iordaniya/', title: 'Iordaniya' },
                { href: 'https://bh.wingie.com/uz/flights/ke-keniya/', title: 'Keniya' },
            ],
        },
        {
            title: 'Mashhur Aviakompaniyalar',
            items: [
                { href: 'https://bh.wingie.com/uz/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/uz/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/uz/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/uz/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/uz/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/uz/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-sr': [
        {
            title: 'Popularne Destinacije',
            items: [
                { href: 'https://bh.wingie.com/sr/flights/to-riyadh/', title: 'Rijad' },
                { href: 'https://bh.wingie.com/sr/flights/to-jeddah/', title: 'Džeda' },
                { href: 'https://bh.wingie.com/sr/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://bh.wingie.com/sr/flights/to-manila/', title: 'Manila' },
                { href: 'https://bh.wingie.com/sr/flights/to-chennai/', title: 'Čenai' },
                { href: 'https://bh.wingie.com/sr/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Popularne Zemlje',
            items: [
                { href: 'https://bh.wingie.com/sr/flights/az-azerbejdzan/', title: 'Azerbejdžan' },
                { href: 'https://bh.wingie.com/sr/flights/bh-bahrejn/', title: 'Bahrein' },
                { href: 'https://bh.wingie.com/sr/flights/eg-egipat/', title: 'Egipat' },
                { href: 'https://bh.wingie.com/sr/flights/in-indija/', title: 'Indija' },
                { href: 'https://bh.wingie.com/sr/flights/jo-jordan/', title: 'Jordan' },
                { href: 'https://bh.wingie.com/sr/flights/ke-kenija/', title: 'Kenija' },
            ],
        },
        {
            title: 'Popularne Avio-kompanije',
            items: [
                { href: 'https://bh.wingie.com/sr/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/sr/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/sr/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/sr/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/sr/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/sr/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-ky': [
        {
            title: 'Популярдуу Багыттар',
            items: [
                { href: 'https://bh.wingie.com/ky/flights/to-riyadh/', title: 'Рияд' },
                { href: 'https://bh.wingie.com/ky/flights/to-jeddah/', title: 'Жидда' },
                { href: 'https://bh.wingie.com/ky/flights/to-dammam/', title: 'Даммам' },
                { href: 'https://bh.wingie.com/ky/flights/to-manila/', title: 'Манила' },
                { href: 'https://bh.wingie.com/ky/flights/to-chennai/', title: 'Ченнай' },
                { href: 'https://bh.wingie.com/ky/flights/to-delhi/', title: 'Дели' },
            ],
        },
        {
            title: 'Популярдуу Өлкөлөр',
            items: [
                { href: 'https://bh.wingie.com/ky/flights/az-azerbayjan/', title: 'Азербайжан' },
                { href: 'https://bh.wingie.com/ky/flights/bh-bahreyn/', title: 'Бахрейн' },
                { href: 'https://bh.wingie.com/ky/flights/eg-egipet/', title: 'Египет' },
                { href: 'https://bh.wingie.com/ky/flights/in-indiya/', title: 'Индия' },
                { href: 'https://bh.wingie.com/ky/flights/jo-iordaniya/', title: 'Иордания' },
                { href: 'https://bh.wingie.com/ky/flights/ke-keniya/', title: 'Кения' },
            ],
        },
        {
            title: 'Популярдуу Авиакомпаниялар',
            items: [
                { href: 'https://bh.wingie.com/ky/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/ky/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/ky/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/ky/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/ky/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/ky/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-tg': [
        {
            title: 'Масҳуртарин Самтҳо',
            items: [
                { href: 'https://bh.wingie.com/tg/flights/to-riyadh/', title: 'Рияд' },
                { href: 'https://bh.wingie.com/tg/flights/to-jeddah/', title: 'Жидда' },
                { href: 'https://bh.wingie.com/tg/flights/to-dammam/', title: 'Даммам' },
                { href: 'https://bh.wingie.com/tg/flights/to-manila/', title: 'Манила' },
                { href: 'https://bh.wingie.com/tg/flights/to-chennai/', title: 'Ченнай' },
                { href: 'https://bh.wingie.com/tg/flights/to-delhi/', title: 'Дели' },
            ],
        },
        {
            title: 'Масҳуртарин Кишварҳо',
            items: [
                { href: 'https://bh.wingie.com/tg/flights/az-ozarboyjon/', title: 'Озарбойҷон' },
                { href: 'https://bh.wingie.com/tg/flights/bh-bahrayn/', title: 'Баҳрайн' },
                { href: 'https://bh.wingie.com/tg/flights/eg-misr/', title: 'Миср' },
                { href: 'https://bh.wingie.com/tg/flights/in-hinduston/', title: 'Ҳиндустон' },
                { href: 'https://bh.wingie.com/tg/flights/jo-urdun/', title: 'Урдун' },
                { href: 'https://bh.wingie.com/tg/flights/ke-keniya/', title: 'Кения' },
            ],
        },
        {
            title: 'Масҳуртарин Авиакомпанияҳо',
            items: [
                { href: 'https://bh.wingie.com/tg/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/tg/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/tg/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/tg/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/tg/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/tg/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-kk': [
        {
            title: 'Танымал Бағыттар',
            items: [
                { href: 'https://bh.wingie.com/kk/flights/to-riyadh/', title: 'Рияд' },
                { href: 'https://bh.wingie.com/kk/flights/to-jeddah/', title: 'Жидда' },
                { href: 'https://bh.wingie.com/kk/flights/to-dammam/', title: 'Даммам' },
                { href: 'https://bh.wingie.com/kk/flights/to-manila/', title: 'Манила' },
                { href: 'https://bh.wingie.com/kk/flights/to-chennai/', title: 'Ченнай' },
                { href: 'https://bh.wingie.com/kk/flights/to-delhi/', title: 'Дели' },
            ],
        },
        {
            title: 'Танымал Елдер',
            items: [
                { href: 'https://bh.wingie.com/kk/flights/az-azerbayjan/', title: 'Әзербайжан' },
                { href: 'https://bh.wingie.com/kk/flights/bh-bahreyn/', title: 'Бахрейн' },
                { href: 'https://bh.wingie.com/kk/flights/eg-misyr/', title: 'Египет' },
                { href: 'https://bh.wingie.com/kk/flights/in-hindistan/', title: 'Үндістан' },
                { href: 'https://bh.wingie.com/kk/flights/jo-iordaniya/', title: 'Иордания' },
                { href: 'https://bh.wingie.com/kk/flights/ke-keniya/', title: 'Кения' },
            ],
        },
        {
            title: 'Танымал Авиакомпаниялар',
            items: [
                { href: 'https://bh.wingie.com/kk/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/kk/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/kk/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/kk/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/kk/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/kk/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-nl': [
        {
            title: 'Populaire Bestemmingen',
            items: [
                { href: 'https://bh.wingie.com/nl/flights/to-riyadh/', title: 'Riyadh' },
                { href: 'https://bh.wingie.com/nl/flights/to-jeddah/', title: 'Jeddah' },
                { href: 'https://bh.wingie.com/nl/flights/to-dammam/', title: 'Dammam' },
                { href: 'https://bh.wingie.com/nl/flights/to-manila/', title: 'Manila' },
                { href: 'https://bh.wingie.com/nl/flights/to-chennai/', title: 'Chennai' },
                { href: 'https://bh.wingie.com/nl/flights/to-delhi/', title: 'Delhi' },
            ],
        },
        {
            title: 'Populaire Landen',
            items: [
                { href: 'https://bh.wingie.com/nl/flights/az-azerbaijan/', title: 'Azerbeidzjan' },
                { href: 'https://bh.wingie.com/nl/flights/bh-bahrain/', title: 'Bahrein' },
                { href: 'https://bh.wingie.com/nl/flights/eg-egypte/', title: 'Egypte' },
                { href: 'https://bh.wingie.com/nl/flights/in-india/', title: 'India' },
                { href: 'https://bh.wingie.com/nl/flights/jo-jordanie/', title: 'Jordanië' },
                { href: 'https://bh.wingie.com/nl/flights/ke-kenia/', title: 'Kenia' },
            ],
        },
        {
            title: 'Populaire Luchtvaartmaatschappijen',
            items: [
                { href: 'https://bh.wingie.com/nl/flights/airlines/saudi-arabian-airlines/', title: 'Saudi Arabian Airlines' },
                { href: 'https://bh.wingie.com/nl/flights/airlines/flynas/', title: 'Flynas' },
                { href: 'https://bh.wingie.com/nl/flights/airlines/qatar-airways/', title: 'Qatar Airways' },
                { href: 'https://bh.wingie.com/nl/flights/airlines/egyptair/', title: 'Egyptair' },
                { href: 'https://bh.wingie.com/nl/flights/airlines/etihad-airways/', title: 'Etihad Airways' },
                { href: 'https://bh.wingie.com/nl/flights/airlines/royal-jordanian/', title: 'Royal Jordanian' },
            ],
        },
    ],
    'bh-ja': [
        {
            title: '人気の目的地',
            items: [
                { title: 'ラスベガス', href: 'https://bh.wingie.com/ja/flights/to-las-vegas/' },
                { title: 'シカゴ', href: 'https://bh.wingie.com/ja/flights/to-chicago/' },
                { title: 'マイアミ', href: 'https://bh.wingie.com/ja/flights/to-miami/' },
                { title: 'カンクン', href: 'https://bh.wingie.com/ja/flights/to-cancun/' },
                { title: 'ロンドン', href: 'https://bh.wingie.com/ja/flights/to-london/' },
                { title: 'ホノルル', href: 'https://bh.wingie.com/ja/flights/to-honolulu/' },
            ],
        },
        {
            title: '人気の国',
            items: [
                { title: 'カナダ', href: 'https://bh.wingie.com/ja/flights/ca-canada/' },
                { title: '中国', href: 'https://bh.wingie.com/ja/flights/cn-china/' },
                { title: 'コスタリカ', href: 'https://bh.wingie.com/ja/flights/cr-costa-rica/' },
                { title: 'ドミニカ共和国', href: 'https://bh.wingie.com/ja/flights/do-dominican-republic/' },
                { title: 'エルサルバドル', href: 'https://bh.wingie.com/ja/flights/sv-el-salvador/' },
                { title: 'フランス', href: 'https://bh.wingie.com/ja/flights/fr-france/' },
            ],
        },
        {
            title: '人気の航空会社',
            items: [
                { title: 'アメリカン・エアラインズ', href: 'https://bh.wingie.com/ja/flights/airlines/american-airlines/' },
                { title: 'デルタ航空', href: 'https://bh.wingie.com/ja/flights/airlines/delta-air-lines/' },
                { title: 'ユナイテッド航空', href: 'https://bh.wingie.com/ja/flights/airlines/united-airlines/' },
                { title: 'アラスカ航空', href: 'https://bh.wingie.com/ja/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://bh.wingie.com/ja/flights/airlines/jetblue/' },
                { title: 'ハワイアン航空', href: 'https://bh.wingie.com/ja/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'bh-zh': [
        {
            title: '热门目的地',
            items: [
                { title: '拉斯维加斯', href: 'https://bh.wingie.com/zh/flights/to-las-vegas/' },
                { title: '芝加哥', href: 'https://bh.wingie.com/zh/flights/to-chicago/' },
                { title: '迈阿密', href: 'https://bh.wingie.com/zh/flights/to-miami/' },
                { title: '坎昆', href: 'https://bh.wingie.com/zh/flights/to-cancun/' },
                { title: '伦敦', href: 'https://bh.wingie.com/zh/flights/to-london/' },
                { title: '火奴鲁鲁', href: 'https://bh.wingie.com/zh/flights/to-honolulu/' },
            ],
        },
        {
            title: '热门国家',
            items: [
                { title: '加拿大', href: 'https://bh.wingie.com/zh/flights/ca-canada/' },
                { title: '中国', href: 'https://bh.wingie.com/zh/flights/cn-china/' },
                { title: '哥斯达黎加', href: 'https://bh.wingie.com/zh/flights/cr-costa-rica/' },
                { title: '多米尼加共和国', href: 'https://bh.wingie.com/zh/flights/do-dominican-republic/' },
                { title: '萨尔瓦多', href: 'https://bh.wingie.com/zh/flights/sv-el-salvador/' },
                { title: '法国', href: 'https://bh.wingie.com/zh/flights/fr-france/' },
            ],
        },
        {
            title: '热门航空公司',
            items: [
                { title: '美国航空', href: 'https://bh.wingie.com/zh/flights/airlines/american-airlines/' },
                { title: '达美航空', href: 'https://bh.wingie.com/zh/flights/airlines/delta-air-lines/' },
                { title: '美联航', href: 'https://bh.wingie.com/zh/flights/airlines/united-airlines/' },
                { title: '阿拉斯加航空', href: 'https://bh.wingie.com/zh/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://bh.wingie.com/zh/flights/airlines/jetblue/' },
                { title: '夏威夷航空', href: 'https://bh.wingie.com/zh/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'bh-ko': [
        {
            title: '인기 목적지',
            items: [
                { title: '라스베이거스', href: 'https://bh.wingie.com/ko/flights/to-las-vegas/' },
                { title: '시카고', href: 'https://bh.wingie.com/ko/flights/to-chicago/' },
                { title: '마이애미', href: 'https://bh.wingie.com/ko/flights/to-miami/' },
                { title: '칸쿤', href: 'https://bh.wingie.com/ko/flights/to-cancun/' },
                { title: '런던', href: 'https://bh.wingie.com/ko/flights/to-london/' },
                { title: '호놀룰루', href: 'https://bh.wingie.com/ko/flights/to-honolulu/' },
            ],
        },
        {
            title: '인기 국가',
            items: [
                { title: '캐나다', href: 'https://bh.wingie.com/ko/flights/ca-canada/' },
                { title: '중국', href: 'https://bh.wingie.com/ko/flights/cn-china/' },
                { title: '코스타리카', href: 'https://bh.wingie.com/ko/flights/cr-costa-rica/' },
                { title: '도미니카 공화국', href: 'https://bh.wingie.com/ko/flights/do-dominican-republic/' },
                { title: '엘살바도르', href: 'https://bh.wingie.com/ko/flights/sv-el-salvador/' },
                { title: '프랑스', href: 'https://bh.wingie.com/ko/flights/fr-france/' },
            ],
        },
        {
            title: '인기 항공사',
            items: [
                { title: '아메리칸 항공', href: 'https://bh.wingie.com/ko/flights/airlines/american-airlines/' },
                { title: '델타 항공', href: 'https://bh.wingie.com/ko/flights/airlines/delta-air-lines/' },
                { title: '유나이티드 항공', href: 'https://bh.wingie.com/ko/flights/airlines/united-airlines/' },
                { title: '알래스카 항공', href: 'https://bh.wingie.com/ko/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://bh.wingie.com/ko/flights/airlines/jetblue/' },
                { title: '하와이안 항공', href: 'https://bh.wingie.com/ko/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'bh-hi': [
        {
            title: 'लोकप्रिय गंतव्य',
            items: [
                { title: 'लास वेगास', href: 'https://bh.wingie.com/hi/flights/to-las-vegas/' },
                { title: 'शिकागो', href: 'https://bh.wingie.com/hi/flights/to-chicago/' },
                { title: 'मियामी', href: 'https://bh.wingie.com/hi/flights/to-miami/' },
                { title: 'कैनकन', href: 'https://bh.wingie.com/hi/flights/to-cancun/' },
                { title: 'लंदन', href: 'https://bh.wingie.com/hi/flights/to-london/' },
                { title: 'होनोलुलु', href: 'https://bh.wingie.com/hi/flights/to-honolulu/' },
            ],
        },
        {
            title: 'लोकप्रिय देश',
            items: [
                { title: 'कनाडा', href: 'https://bh.wingie.com/hi/flights/ca-canada/' },
                { title: 'चीन', href: 'https://bh.wingie.com/hi/flights/cn-china/' },
                { title: 'कोस्टा रिका', href: 'https://bh.wingie.com/hi/flights/cr-costa-rica/' },
                { title: 'डोमिनिकन गणराज्य', href: 'https://bh.wingie.com/hi/flights/do-dominican-republic/' },
                { title: 'अल सल्वाडोर', href: 'https://bh.wingie.com/hi/flights/sv-el-salvador/' },
                { title: 'फ्रांस', href: 'https://bh.wingie.com/hi/flights/fr-france/' },
            ],
        },
        {
            title: 'लोकप्रिय एयरलाइनें',
            items: [
                { title: 'अमेरिकन एयरलाइन्स', href: 'https://bh.wingie.com/hi/flights/airlines/american-airlines/' },
                { title: 'डेल्टा एयरलाइन्स', href: 'https://bh.wingie.com/hi/flights/airlines/delta-air-lines/' },
                { title: 'यूनाइटेड एयरलाइन्स', href: 'https://bh.wingie.com/hi/flights/airlines/united-airlines/' },
                { title: 'अलास्का एयरलाइन्स', href: 'https://bh.wingie.com/hi/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://bh.wingie.com/hi/flights/airlines/jetblue/' },
                { title: 'हवाई एयरलाइन्स', href: 'https://bh.wingie.com/hi/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'bh-ta': [
        {
            title: 'பிரபலமான இலக்குகள்',
            items: [
                { title: 'லாஸ் வெகாஸ்', href: 'https://bh.wingie.com/ta/flights/to-las-vegas/' },
                { title: 'சிகாகோ', href: 'https://bh.wingie.com/ta/flights/to-chicago/' },
                { title: 'மியாமி', href: 'https://bh.wingie.com/ta/flights/to-miami/' },
                { title: 'கான்கன்', href: 'https://bh.wingie.com/ta/flights/to-cancun/' },
                { title: 'லண்டன்', href: 'https://bh.wingie.com/ta/flights/to-london/' },
                { title: 'ஓனோலுலு', href: 'https://bh.wingie.com/ta/flights/to-honolulu/' },
            ],
        },
        {
            title: 'பிரபலமான நாடுகள்',
            items: [
                { title: 'கனடா', href: 'https://bh.wingie.com/ta/flights/ca-canada/' },
                { title: 'சீனா', href: 'https://bh.wingie.com/ta/flights/cn-china/' },
                { title: 'கோஸ்டா ரிக்கா', href: 'https://bh.wingie.com/ta/flights/cr-costa-rica/' },
                { title: 'டொமினிக்கன் குடியரசு', href: 'https://bh.wingie.com/ta/flights/do-dominican-republic/' },
                { title: 'எல் சால்வடோர்', href: 'https://bh.wingie.com/ta/flights/sv-el-salvador/' },
                { title: 'பிரான்சு', href: 'https://bh.wingie.com/ta/flights/fr-france/' },
            ],
        },
        {
            title: 'பிரபலமான விமான நிறுவனங்கள்',
            items: [
                { title: 'அமெரிக்கன் ஏர்லைன்ஸ்', href: 'https://bh.wingie.com/ta/flights/airlines/american-airlines/' },
                { title: 'டெல்டா ஏர்லைன்ஸ்', href: 'https://bh.wingie.com/ta/flights/airlines/delta-air-lines/' },
                { title: 'யுனைட்டட் ஏர்லைன்ஸ்', href: 'https://bh.wingie.com/ta/flights/airlines/united-airlines/' },
                { title: 'அலாஸ்கா ஏர்லைன்ஸ்', href: 'https://bh.wingie.com/ta/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://bh.wingie.com/ta/flights/airlines/jetblue/' },
                { title: 'ஹவாய் ஏர்லைன்ஸ்', href: 'https://bh.wingie.com/ta/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'bh-th': [
        {
            title: 'จุดหมายยอดนิยม',
            items: [
                { title: 'ลาสเวกัส', href: 'https://bh.wingie.com/th/flights/to-las-vegas/' },
                { title: 'ชิคาโก', href: 'https://bh.wingie.com/th/flights/to-chicago/' },
                { title: 'ไมอามี', href: 'https://bh.wingie.com/th/flights/to-miami/' },
                { title: 'แคนคูน', href: 'https://bh.wingie.com/th/flights/to-cancun/' },
                { title: 'ลอนดอน', href: 'https://bh.wingie.com/th/flights/to-london/' },
                { title: 'โฮโนลูลู', href: 'https://bh.wingie.com/th/flights/to-honolulu/' },
            ],
        },
        {
            title: 'ประเทศยอดนิยม',
            items: [
                { title: 'แคนาดา', href: 'https://bh.wingie.com/th/flights/ca-canada/' },
                { title: 'จีน', href: 'https://bh.wingie.com/th/flights/cn-china/' },
                { title: 'คอสตาริกา', href: 'https://bh.wingie.com/th/flights/cr-costa-rica/' },
                { title: 'สาธารณรัฐโดมินิกัน', href: 'https://bh.wingie.com/th/flights/do-dominican-republic/' },
                { title: 'เอลซัลวาดอร์', href: 'https://bh.wingie.com/th/flights/sv-el-salvador/' },
                { title: 'ฝรั่งเศส', href: 'https://bh.wingie.com/th/flights/fr-france/' },
            ],
        },
        {
            title: 'สายการบินยอดนิยม',
            items: [
                { title: 'อเมริกันแอร์ไลน์', href: 'https://bh.wingie.com/th/flights/airlines/american-airlines/' },
                { title: 'เดลต้า แอร์ไลน์', href: 'https://bh.wingie.com/th/flights/airlines/delta-air-lines/' },
                { title: 'ยูไนเต็ด แอร์ไลน์', href: 'https://bh.wingie.com/th/flights/airlines/united-airlines/' },
                { title: 'อลาสก้าแอร์ไลน์', href: 'https://bh.wingie.com/th/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://bh.wingie.com/th/flights/airlines/jetblue/' },
                { title: 'ฮาวายแอนแอร์ไลน์', href: 'https://bh.wingie.com/th/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'bh-ur': [
        {
            title: 'مشہور منزلیں',
            items: [
                { title: 'لاس ویگاس', href: 'https://bh.wingie.com/ur/flights/to-las-vegas/' },
                { title: 'شکاگو', href: 'https://bh.wingie.com/ur/flights/to-chicago/' },
                { title: 'میامی', href: 'https://bh.wingie.com/ur/flights/to-miami/' },
                { title: 'کینکن', href: 'https://bh.wingie.com/ur/flights/to-cancun/' },
                { title: 'لندن', href: 'https://bh.wingie.com/ur/flights/to-london/' },
                { title: 'ہونولولو', href: 'https://bh.wingie.com/ur/flights/to-honolulu/' },
            ],
        },
        {
            title: 'مشہور ممالک',
            items: [
                { title: 'کینیڈا', href: 'https://bh.wingie.com/ur/flights/ca-canada/' },
                { title: 'چین', href: 'https://bh.wingie.com/ur/flights/cn-china/' },
                { title: 'کوسٹا ریکا', href: 'https://bh.wingie.com/ur/flights/cr-costa-rica/' },
                { title: 'ڈومینیکن جمہوریہ', href: 'https://bh.wingie.com/ur/flights/do-dominican-republic/' },
                { title: 'ایل سیلواڈور', href: 'https://bh.wingie.com/ur/flights/sv-el-salvador/' },
                { title: 'فرانس', href: 'https://bh.wingie.com/ur/flights/fr-france/' },
            ],
        },
        {
            title: 'مشہور ایئر لائنز',
            items: [
                { title: 'امریکن ایئرلائنز', href: 'https://bh.wingie.com/ur/flights/airlines/american-airlines/' },
                { title: 'ڈیلٹا ایئر لائنز', href: 'https://bh.wingie.com/ur/flights/airlines/delta-air-lines/' },
                { title: 'یونائیٹڈ ایئرلائنز', href: 'https://bh.wingie.com/ur/flights/airlines/united-airlines/' },
                { title: 'الاسکا ایئرلائنز', href: 'https://bh.wingie.com/ur/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://bh.wingie.com/ur/flights/airlines/jetblue/' },
                { title: 'ہوائی ایئرلائنز', href: 'https://bh.wingie.com/ur/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ],
    'bh-ka': [
        {
            title: 'პოპულარული მიმართულებები',
            items: [
                { title: 'ლას-ვეგასი', href: 'https://bh.wingie.com/ka/flights/to-las-vegas/' },
                { title: 'ჩიკაგო', href: 'https://bh.wingie.com/ka/flights/to-chicago/' },
                { title: 'მაიამი', href: 'https://bh.wingie.com/ka/flights/to-miami/' },
                { title: 'კანკუნი', href: 'https://bh.wingie.com/ka/flights/to-cancun/' },
                { title: 'ლონდონი', href: 'https://bh.wingie.com/ka/flights/to-london/' },
                { title: 'ჰონოლულუ', href: 'https://bh.wingie.com/ka/flights/to-honolulu/' },
            ],
        },
        {
            title: 'პოპულარული ქვეყნები',
            items: [
                { title: 'კანადა', href: 'https://bh.wingie.com/ka/flights/ca-canada/' },
                { title: 'ჩინეთი', href: 'https://bh.wingie.com/ka/flights/cn-china/' },
                { title: 'კოსტა-რიკა', href: 'https://bh.wingie.com/ka/flights/cr-costa-rica/' },
                { title: 'დომინიკელთა რესპუბლიკა', href: 'https://bh.wingie.com/ka/flights/do-dominican-republic/' },
                { title: 'სალვადორი', href: 'https://bh.wingie.com/ka/flights/sv-el-salvador/' },
                { title: 'საფრანგეთი', href: 'https://bh.wingie.com/ka/flights/fr-france/' },
            ],
        },
        {
            title: 'პოპულარული ავიაკომპანიები',
            items: [
                { title: 'ამერიკის ავიაკომპანია', href: 'https://bh.wingie.com/ka/flights/airlines/american-airlines/' },
                { title: 'დელტა ეარ ლაინზი', href: 'https://bh.wingie.com/ka/flights/airlines/delta-air-lines/' },
                { title: 'იუნაიტედ ერლაინზი', href: 'https://bh.wingie.com/ka/flights/airlines/united-airlines/' },
                { title: 'ალასკას ავიაკომპანია', href: 'https://bh.wingie.com/ka/flights/airlines/alaska-airlines/' },
                { title: 'JetBlue', href: 'https://bh.wingie.com/ka/flights/airlines/jetblue/' },
                { title: 'ჰავაუს ავიაკომპანია', href: 'https://bh.wingie.com/ka/flights/airlines/hawaiian-airlines/' },
            ],
        },
    ]
}